export default {
  SHOW_LINKED_CALENDAR: 'CALENDAR.SHOW_LINKED_CALENDAR',
  HIDE_LINKED_CALENDAR: 'CALENDAR.HIDE_LINKED_CALENDAR',
}
